import { Box, Grid, Heading, Text, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import mainVideo from "../../assets/videos/Black General Subjects Online Education YouTube Video Ad.mp4"


const CoursePage = () => {
    const [lectureNumber,setLectureNumber]=useState(0)

    const lectures=[
        {
        _id : "abcd",
        title:'sample',
        description:'huehuehuehuehue',
        video:{
            url:'address'
            }
        },
        {
        _id : "abcd2",
        title:'sample2',
        description:'huehuehuehuehue',
        video:{
            url:'address'
            }
        },
        {
        _id : "abcd3",
        title:'sample3',
        description:'huehuehuehuehue',
        video:{
            url:'address'
            }
        }
    ]
  return (
    <Grid minH={'90vh'} templateColumns={['1fr','3fr 1fr']}>
        <Box>
            <video width={'100%'}
                   controls 
                   controlsList="nodownload noremoteplayback" 
                   disablePictureInPicture
                   disableRemotePlayback
                   src={mainVideo}
            >
            </video>
            <Heading m='4' children={`#${lectureNumber+1} ${lectures[lectureNumber].title}`}/>
            <Heading children='Description' m='4'/>
            <Text m='4' children={`${lectures[lectureNumber].description}`}  />
        </Box>
        <VStack>
            {
                lectures.map((item,index)=>(
                    <button onClick={()=> setLectureNumber(index)} key={item._id} style={{width:'100%',padding:'1rem',textAlign:'center',margin:0,borderBottom:'1px solid rgba(0,0,0,0.2'}}>
                        <Text noOfLines={1}>
                            #{index+1} {item.title}
                        </Text>
                    </button>
                ))
            }
        </VStack>
    </Grid>
  )
}

export default CoursePage